import { EnumSchema, FromSchema } from '../SchemaOperations';
import { z } from 'zod';
import { EntityReferenceType } from './entity.reference.type';
import { Currency } from '../../../../models/src/lib/currency.enum';

export const EntityReferenceSchema = z.object({
    id: z.string(),
    type: EnumSchema(EntityReferenceType),
});

export const EntityReferenceWithAmountSchema = EntityReferenceSchema.merge(
    z.object({
        amount: z.number(),
        currency: EnumSchema(Currency).optional(),
        discount: z.number().optional(),
        externalId: z.string().optional(),
    }),
);

export class EntityReference extends FromSchema(EntityReferenceSchema) {
    id: string;
    type: EntityReferenceType;
}

export class EntityReferenceWithAmount extends FromSchema(EntityReferenceWithAmountSchema) {
    id: string;
    type: EntityReferenceType;
    amount: number;
    currency?: Currency;
    discount?: number;
    externalId?: string;
}
